import { memo, useCallback } from 'react';
import { useTournament } from '../../../store';
import { MenuItem } from '../../MenuItem';

export const TournamentItem = memo((props) => {
  const {
    serviceId,
    tournamentId,
    categoryId,
    onClick: onClickProp,
    isActive,
    multiple,
    withCounter = false,
    basePath
  } = props;
  const path = `${basePath}/${tournamentId}`;

  const { tournamentName, eventCount } = useTournament(tournamentId, serviceId);

  const onClick = useCallback(
    (e) => {
      e.preventDefault();
      onClickProp?.(tournamentId, categoryId);
    },
    [categoryId, onClickProp, tournamentId]
  );

  return (
    <MenuItem
      name={tournamentName}
      to={path}
      count={eventCount}
      onClick={onClick}
      isActive={isActive}
      withCounter={withCounter}
      withCheckbox={multiple}
      fontSize="s"
      dataAttr={{ 'data-role': `tournament-id-${tournamentId}` }}
    />
  );
});

TournamentItem.displayName = 'TournamentItem';
